import React from 'react'
import PropTypes from 'prop-types'

import AddToQueueButton from '../AddToQueueButton/AddToQueueButton'
import AddToCartButton from '../AddToCartButton/AddToCartButton'


const AddToQueueOrCartButton = ({ addTo, ...rest }) => {
  if (addTo === 'queue') {
    return <AddToQueueButton {...rest} />
  }

  if (addTo === 'cart') {
    return <AddToCartButton {...rest} />
  }

  throw new Error(`wrong addTo (${addTo}) passed to AddToQueueOrCartButton`)
}

AddToQueueOrCartButton.propTypes = {
  addTo: PropTypes.oneOf([ 'queue', 'cart' ]).isRequired,
  snowplowMetadata: PropTypes.object,
}


export default AddToQueueOrCartButton
